import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Alert } from 'app/models/alert';
import { LogoutService } from '../../standalone-core/features';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sma-web-alerts',
  template: `
    @for (alert of alerts; track alert) {
      <div
        [class]="'alert alert-' + alert.type"
        [attr.data-smrtnc-test]="'layout--alert-' + alert.type"
        animate.enter="alert-enter"
        animate.leave="alert-leave"
        role="alert"
        >
        <div class="fwe-d-flex fwe-flex-row">
          <div class="overflow-ellipsis">
            <dl>
              @if (!alert?.title) {
                <dt>{{ 'ALERT.INFO' | translate }}</dt>
              }
              @if (alert?.title) {
                <dt>{{ alert.title | translate }}</dt>
              }
              @if (alert.showLogout) {
                <dl>
                  <span>{{ 'ALERT.LOGIN_TEXT' | translate }}</span>
                  <button type="button" class="fwe-ml-2 fwe-btn fwe-btn-link fwe-dark alert-link" (click)="onLogout()">
                    <span>{{ 'ALERT.LOGIN_BUTTON' | translate }}</span>
                    <i class="fwe-ml-1 fwe-icon fwe-menu-logout"></i>
                  </button>
                </dl>
              }
            </dl>
            @if (alert.type === 'danger') {
              <dl class="fwe-m-0">
                <dt>{{ 'ALERT.ERROR_TITLE' | translate }}</dt>
                <dd>
                  <pre style="color: #6c000d;">{{ alert.message | translate }}</pre>
                </dd>
              </dl>
            }
            @if (alert.type !== 'danger') {
              <div class="fwe-m-0 fwe-mb-3">{{ alert.message | translate }}</div>
            }
          </div>
          <div class="fwe-ml-auto">
            <button type="button" class="close" aria-label="Close" (click)="dismissed.emit(alert.id)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    }
    `,
  styleUrls: ['alerts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class AlertsComponent {
  private logoutService = inject(LogoutService);

  @Input() alerts: Alert[];
  @Output() dismissed = new EventEmitter<string>();

  onLogout(): void {
    this.logoutService.logout();
  }
}
